export default "__VITE_ASSET__ktHBs$sRFmG3poP1SXYXfg__";